import app from 'app';

import recommendationsSliders from './product/recommendations-sliders';

app.add({
  'product-recommendations-sliders': recommendationsSliders,
});
